// extracted by mini-css-extract-plugin
export var bodyRow = "_eu-d";
export var cardColumns = "_eu-e";
export var ellipsesOverflow = "_eu-2";
export var flatBottomCorners = "_eu-3";
export var flatTopCorners = "_eu-4";
export var headerActionsDropdown = "_eu-f";
export var headerBottomRow = "_eu-c";
export var headerTopRow = "_eu-b";
export var orderDetailsWrapper = "_eu-0";
export var orderInfoContainer = "_eu-1";
export var productDetails = "_eu-9";
export var productImage = "_eu-5";
export var responsiveTable = "_eu-8";
export var shipmentContainer = "_eu-a";
export var tableBottomLeft = "_eu-6";
export var tableBottomRight = "_eu-7";